<template>
  <div class="card-text text-break my-4" v-html="addLinkTagsToBody" />
</template>

<script>

export default {
  name: "NotificationBodyBrowseItem",
  props: {
    value: {
      type: String,
      required: true
    },
  },
  computed: {
    addLinkTagsToBody() {
      // PHP��htmlspecialchars�֐��ƃZ�b�g��XSS�΍�AURL�����N�����L����
      return this.value ? this.value.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' target='_blank'>$1</a>") : '';
    }
  },
}
</script>
